module.exports = __webpack_public_path__ + "static/media/feature-2.125f5425.svg";